/* eslint-disable react/no-unescaped-entities */
import { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import myContext from "../../../Context/myContext";
import { Timestamp, addDoc, collection } from "firebase/firestore";
import { auth, fireDB } from "../../../firebase/FirebaseConfig";
import { createUserWithEmailAndPassword } from "firebase/auth";
import toast from "react-hot-toast";
import Loader from "../../loader/Loader";

const Signup = () => {
    const context = useContext(myContext);
    const { loading, setLoading } = context;
    const navigate = useNavigate();

    // User Signup State
    const [userSignup, setUserSignup] = useState({
        name: "",
        email: "",
        password: "",
        role: "user"
    });

    /**========================================================================
     *                          User Signup Function 
     *========================================================================**/
    const userSignupFunction = async () => {
        // Validation
        if (userSignup.name === "" || userSignup.email === "" || userSignup.password === "") {
            toast.error("All fields are required");
            return; // Exit early if validation fails
        }

        setLoading(true);

        try {
            const userCredential = await createUserWithEmailAndPassword(auth, userSignup.email, userSignup.password);
            const user = {
                name: userSignup.name,
                email: userCredential.user.email,
                uid: userCredential.user.uid,
                role: userSignup.role,
                time: Timestamp.now(),
                date: new Date().toLocaleString("en-US", {
                    month: "short",
                    day: "2-digit",
                    year: "numeric",
                })
            };

            const userRef = collection(fireDB, "user");
            await addDoc(userRef, user);

            setUserSignup({
                name: "",
                email: "",
                password: "",
                role: "user"
            });

            toast.success("Signup successful");
            navigate('/login');
        } catch (error) {
            console.error("Error during signup:", error.code, error.message);
            toast.error("Signup failed: " + (error.message || "An unknown error occurred"));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='d-flex justify-content-center align-items-center vh-100'>
            {loading && <Loader />}
            {/* Signup Form */}
            <div className="bg-light p-4 border rounded shadow-sm" style={{ width: '350px' }}>
                {/* Top Heading */}
                <h2 className='text-center text-primary mb-4'>Signup</h2>

                {/* Full Name Input */}
                <div className="mb-3">
                    <input
                        type="text"
                        placeholder='Full Name'
                        value={userSignup.name}
                        onChange={(e) => setUserSignup({ ...userSignup, name: e.target.value })}
                        className='form-control'
                    />
                </div>

                {/* Email Input */}
                <div className="mb-3">
                    <input
                        type="email"
                        placeholder='Email Address'
                        value={userSignup.email}
                        onChange={(e) => setUserSignup({ ...userSignup, email: e.target.value })}
                        className='form-control'
                    />
                </div>

                {/* Password Input */}
                <div className="mb-3">
                    <input
                        type="password"
                        placeholder='Password'
                        value={userSignup.password}
                        onChange={(e) => setUserSignup({ ...userSignup, password: e.target.value })}
                        className='form-control'
                    />
                </div>

                {/* Signup Button */}
                <div className="mb-3">
                    <button
                        type='button'
                        onClick={userSignupFunction}
                        className='btn btn-primary w-100'
                    >
                        Signup
                    </button>
                </div>

                {/* Link to Login */}
                <div className="text-center">
                    <h6 className='text-dark'>
                        Have an account? <Link className='text-primary' to='/login'>Login</Link>
                    </h6>
                </div>
            </div>
        </div>
    );
};

export default Signup;
